module.exports = __webpack_public_path__ + "img/download.a48a0dfa.svg";